<template>
    <div>
        <div v-if="loading" class="py-5">
            <loader v-if="loading"></loader>
        </div>

        <div class="o-booking-header cl-white" :class="{
            'bg-green': !!booking,
            'bg-red': !booking,
        }" v-if="!loading">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center py-3">
                        <h2 class="c-ttl c-ttl--mdp">{{ booking ? 'Thank you! '+booking.trip.out.destination.name+' is waiting' : 'Error! Booking not found or payment not proccessed yet' }}</h2>

                        <p class="mb-0 mt-1" v-if="booking">
                            We have sent you a confirmation email with the tickets attached to <strong>{{ booking.contact.email }}</strong>
                        </p>
                        <div v-else>
                            <p class="mb-0 mt-1">Your payment has not been registered yet. Please try reloading this page in a few minutes to check again.</p>
                            <p class="mb-0 mt-1">If you are still seeing this error after refreshing the page we please ask you <strong><u>NOT</u></strong> to make another booking but to contact Venezia Lines on <a class="cl-white" href="mailto:sales@venezialines.com">sales@venezialines.com</a>, you should receive a reply within maximum 48 hours.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container" v-if="booking && !loading">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="mw-970 mx-auto">
                        <div class="c-section">
                            <section class="o-bk-box box-sh bg-white is-rounded mt-3">
                                <div class="d-md-flex align-items-center justify-content-between">
                                    <div>
                                        <div class="o-bk-box__title d-flex align-items-center">
                                        <span
                                            class="icon-luggage is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
                                            <h3 class="c-ttl c-ttl--mdp ml-3">Your booking confirmation</h3>
                                        </div>
                                    </div>

                                    <div class="mt-4 mt-md-0">
                                        <button class="btn btn-white-alt-sec is-smaller txt-init" onclick="window.print()">
                                            <span class="icon-print mr-2"></span>Print this page
                                        </button>
                                    </div>
                                </div>

                                <p class="mt-3 mb-5 lh-xl cl-dark fs-14">
                                    We kindly ask you to check all passenger details displayed on the ticket.
                                    <br>
                                    If during check-in, the details of your ticket do not correspond to the document used for travel, boarding may be denied.
                                </p>

                                <table class="o-bk-table w-100">
                                    <thead>
                                        <tr>
                                            <th colspan="3">Boat trip</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Outward</span>
                                                <span>{{ booking.trip.out.origin.name }}</span><span
                                                class="icon-arrow-right-alt cl-sec-l mx-2 fs-10"></span><span
                                                class="fw-sb">{{ booking.trip.out.destination.name }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Date</span>
                                                <span>{{ $moment(booking.trip.out.departure).format('ddd DD MMM') }}</span>
                                            </td>

                                            <td>
                                                <div class="d-flex">
                                                    <div>
                                                        <span class="d-block fw-r fs-14 mb-2">Departure</span>
                                                        <span>{{ $moment(booking.trip.out.departure).format('HH:mm') }}</span>
                                                    </div>

                                                    <div class="pl-4">
                                                        <span class="d-block fw-r fs-14 mb-2">Arrival</span>
                                                        <span>{{ $moment(booking.trip.out.arrival).format('HH:mm') }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                        <template v-if="booking.trip.ret">
                                            <tr>
                                                <td class="is-separator" colspan="3"></td>
                                            </tr>
                                            
                                            <tr>
                                                <td>
                                                    <span class="d-block fw-r fs-14 mb-2">Return</span>
                                                    <span>{{ booking.trip.ret.origin.name }}</span><span
                                                    class="icon-arrow-right-alt cl-sec-l mx-2 fs-10"></span><span
                                                    class="fw-sb">{{ booking.trip.ret.destination.name }}</span>
                                                </td>

                                                <td>
                                                    <span class="d-block fw-r fs-14 mb-2">Date</span>
                                                    <span>{{ $moment(booking.trip.ret.departure).format('ddd DD MMM') }}</span>
                                                </td>

                                                <td>
                                                    <div class="d-flex">
                                                        <div>
                                                            <span class="d-block fw-r fs-14 mb-2">Departure</span>
                                                            <span>{{ $moment(booking.trip.ret.departure).format('HH:mm') }}</span>
                                                        </div>

                                                        <div class="pl-4">
                                                            <span class="d-block fw-r fs-14 mb-2">Arrival</span>
                                                            <span>{{ $moment(booking.trip.ret.arrival).format('HH:mm') }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>

                                <table class="o-bk-table w-100" v-if="prices.transfer">
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                Transfer service
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Pick up point</span>
                                                <span>
                                                    {{ prices.transfer.name }}
                                                </span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Data</span>
                                                <span>{{ $moment(booking.trip.out.departure).format('ddd DD MMM') }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Schedule</span>
                                                <span>{{ prices.transfer.time.substring(0, 5) }}</span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="is-separator" colspan="3"></td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Pick up point</span>
                                                <span>
                                                    {{ booking.trip.ret.destination.name }}
                                                </span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Data</span>
                                                <span>{{ $moment(booking.trip.ret.arrival).format('ddd DD MMM') }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Schedule</span>
                                                <span>{{ $moment(booking.trip.ret.arrival).format('HH:mm') }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <div class="is-rounded bg-sec-light-hover p-3 mt-2" v-for="ticket in booking.tickets" v-bind:key="ticket.number">
                                    <div class="d-md-flex justify-content-between">
                                        <div>
                                            <div class="mb-2">
                                                <span class="fw-r">Name:</span>&nbsp;<strong class="txt-upper">{{ ticket.passenger.name }}</strong>
                                            </div>

                                            <div class="mb-2">
                                                <span class="fw-r">Surname:</span>&nbsp;<strong class="txt-upper">{{ ticket.passenger.surname }}</strong>
                                            </div>

                                            <div class="mb-2">
                                                <span class="fw-r">Gender:</span>&nbsp;<strong>{{ ticket.passenger.gender == 'M' ? 'Male' : 'Female' }}</strong>
                                            </div>
                                        </div>
                                        
                                        <div>
                                            <div class="mb-2">
                                                <span class="fw-r">Date of birth:</span>&nbsp;<strong>{{ $moment(ticket.passenger.date_of_birth).format('DD/MM/YYYY') }}</strong>
                                            </div>

                                            <div class="mb-2">
                                                <span class="fw-r">Document:</span>&nbsp;<strong>{{ ticket.passenger.document_type }} {{ ticket.passenger.document_number }}</strong>
                                            </div>

                                            <div class="mb-2">
                                                <span class="fw-r">Country of nationality:</span>&nbsp;<strong>{{ getCountryName(ticket.passenger.nationality) }}</strong>
                                            </div>
                                        </div>
                                        
                                        <div>
                                            <div class="mb-2">
                                                <span class="fw-r">Ticket number:</span>&nbsp;<strong>{{ ticket.number }}</strong>
                                            </div>

                                            <div class="mb-2">
                                                <span class="fw-r">Class:</span>&nbsp;<strong>{{ ticket.class.name }}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-md-flex align-items-center justify-content-between mt-2">
                                        <template v-if="luggageInfo.free > 0 && ticket.passenger.category != 'INF'">
                                            <strong><span class="icon-luggage mr-2"></span>{{ luggageInfo.free }} check-in luggage included in your ticket</strong>
                                        </template>
                                        <template v-else>
                                            <strong><span class="icon-luggage mr-2"></span>No check-in luggage included in your ticket</strong>
                                        </template>
                                        
                                        <div class="mt-4 mt-md-0">
                                            <a :href="ticket.url" class="btn btn-secondary is-smaller txt-init">
                                                Download ticket
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <table class="o-bk-table w-100 mt-5">
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <span class="cl-sec">Contact details</span>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td class="lh-xl">
                                                <span class="fw-r fs-14">Email:</span>&nbsp;<span>{{ booking.contact.email }}</span><br>
                                                <span class="fw-r fs-14">Phone:</span>&nbsp;<span>{{ booking.contact.phone }}</span><br>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

        <!--
        $prices = [
            'passengers' => [],
            'supplements' => [],
            'luggage' => [],
        ];
        foreach ($booking->tickets as $ticket) {
            $key = $ticket->passenger->category;

            if (! array_key_exists($key, $prices['passengers'])) {
                $prices['passengers'][$key] = [
                    'category' => $age_groups[$ticket->passenger->category],
                    'quantity' => 0,
                    'total' => 0,
                    'class' => $ticket->class->name,
                ];
            }

            $prices['passengers'][$key]['quantity'] += 1;
            $prices['passengers'][$key]['total'] += $ticket->passenger->prices->out->total;
            if ($ticket->passenger->prices->ret) {
                $prices['passengers'][$key]['total'] += $ticket->passenger->prices->ret->total;
            }

            if ($ticket->luggage) {
                if (empty($prices['luggage'])) {
                    $prices['luggage'] = [
                        'name' => $ticket->luggage->name,
                        'quantity' => 0,
                        'total' => 0,
                    ];
                }
                $prices['luggage']['quantity'] += $ticket->luggage->quantity;
                $prices['luggage']['total'] += $ticket->luggage->prices->out->total;
                if ($ticket->luggage->prices->ret) {
                    $prices['luggage']['total'] += $ticket->luggage->prices->ret->total;
                }
            }

            if ($ticket->supplements) {
                foreach ($ticket->supplements as $supplement) {
                    if ( ! isset($prices['supplements'][$supplement->id])) {
                        $prices['supplements'][$supplement->id] = [
                            'name' => $supplement->name,
                            'quantity' => 0,
                            'total' => 0,
                        ];
                    }
                    $prices['supplements'][$supplement->id]['quantity'] += $supplement->quantity;
                    $prices['supplements'][$supplement->id]['total'] += $supplement->prices->out->total;
                    if ($supplement->prices->ret) {
                        $prices['supplements'][$supplement->id]['total'] += $supplement->prices->ret->total;
                    }
                }
            }
        }

        -->

                                <table class="o-bk-table w-100 mt-5">
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <span class="cl-sec">Price details</span>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr class="before-info-row" v-for="(ticket, index) in prices.tickets" v-bind:key="index">
                                            <td>
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <span class="fw-r fs-14">
                                                            {{ ticket.quantity }} x
                                                            {{ ticket.category }} ticket / {{ ticket.class }}
                                                        </span>
                                                        <br>
                                                        <!-- /*span class="cl-red fs-14">
                                                            Non refundable
                                                        </span*/ -->
                                                    </div>

                                                    <strong class="pl-2">
                                                        {{ currency(ticket.total) }}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr class="before-info-row" v-if="prices.transfer">
                                            <td>
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <span class="fw-r fs-14">
                                                            {{ prices.transfer.quantity }} x Transfer {{ prices.transfer.name }}
                                                        </span>
                                                        <br>
                                                        <!-- /*span class="cl-red fs-14">
                                                            Non refundable
                                                        </span*/ -->
                                                    </div>

                                                    <strong class="pl-2">
                                                        {{ currency(prices.transfer.total) }}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr class="before-info-row" v-if="prices.luggage.quantity">
                                            <td>
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <span class="fw-r fs-14">
                                                            {{ prices.luggage.quantity }} x Extra Luggage
                                                        </span>
                                                        <br>
                                                        <!-- /*span class="cl-red fs-14">
                                                            Non refundable
                                                        </span*/ -->
                                                    </div>

                                                    <strong class="pl-2">
                                                        {{ currency(prices.luggage.total) }}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr class="before-info-row" v-for="supplement in prices.supplements" v-bind:key="supplement.code">
                                            <td>
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <span class="fw-r fs-14">
                                                            {{ supplement.quantity }} x {{ supplement.name }}
                                                        </span>
                                                        <br>
                                                        <!-- /*span class="cl-red fs-14">
                                                            Non refundable
                                                        </span*/ -->
                                                    </div>

                                                    <strong class="pl-2">
                                                        {{ currency(supplement.total) }}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="is-info bt">
                                                <div class="d-flex justify-content-between">
                                                    <div class="c-ttl--md fw-sb">Total</div>

                                                    <strong class="cl-prim c-ttl--md pl-2">
                                                        {{ currency(booking.value) }}
                                                    </strong>
                                                </div>
                                                <div class="cl-red fs-14 mt-2 text-right" v-if="!booking.refundable"><strong>Non refundable</strong></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </section>

                            <section class="o-bk-box box-sh bg-white is-rounded mt-3">
                                <h2 class="c-ttl c-ttl--md mb-3">
                                    Directions to port
                                </h2>

                                <!--
                                    $trip_ports = [$booking->trip->out->origin->id, $booking->trip->out->destination->id];
                                    if ($booking->trip->ret) {
                                        $trip_ports[] = $booking->trip->ret->origin->id;
                                        $trip_ports[] = $booking->trip->ret->destination->id;
                                    }
                                    $trip_ports = array_unique($trip_ports);
                                -->
                                
                                <div class="row">
                                    <div
                                        v-for="(port, index) in portLocations"
                                        v-bind:key="port.id"
                                        class="col-md-6"
                                        :class="{
                                            'mt-4': index > 1,
                                            'mt-sm-0': index == 1,
                                        }">
                                        <div class="o-bk-confirm-map">
                                            <div>
                                                <div class="o-bk-confirm-map__map is-rounded"
                                                    :id="'port-map-'+port.id"></div>
                                            </div>
                                            
                                            <div class="lh-xl cl-dark">
                                                {{ port.address }}<br>
                                                <a
                                                    :href="'https://maps.google.com/?q='+port.lat+','+port.lng"
                                                    class="c-link is-rev cl-sec-l"
                                                    target="_blank">Open in Google Maps</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- /*
                                <div class="my-5">
                                    <h2 class="c-ttl c-ttl--md">
                                        Ti serve aiuto con la prenotazione?
                                    </h2>
                                    
                                    <ul class="o-bk-confirm-doc-list cl-dark">
                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>
                                            
                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>

                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>

                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>

                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>

                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>

                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>

                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="my-5">
                                    <h2 class="c-ttl c-ttl--md">
                                        Contatti utili
                                    </h2>

                                    <ul class="o-bk-confirm-doc-list cl-dark">
                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>

                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>

                                        <li>
                                            <div>
                                                Informazioni sui documenti
                                            </div>

                                            <div>
                                                <a class="c-link is-rev cl-sec-l" href="#">
                                                    Documenti per il viaggio
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div class="text-center">
                                    <a class="btn btn-white-alt-sec is-smaller txt-init" href="#">
                                        <span class="icon-print mr-2"></span>Print this page
                                    </a>
                                </div>
                                */ -->
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Loader from '../components/Loader.vue'
import countries from '../constants/countries'
export default {
  components: { Loader },
    data() {
        return {
            bookingNumber: null,
            signature: null,
            loading: true,
            booking: null,
            luggageInfo: {
                free: 0,
                extra: false,
            },
            interval: null,
        }
    },
    computed: {
        ...mapGetters([
            'getPortById',
        ]),
        portLocations() {
            let ports = []

            ports.push(this.getPortById(this.booking.trip.out.origin.id))
            ports.push(this.getPortById(this.booking.trip.out.destination.id))

            if (this.booking.trip.ret) {
                if (this.booking.trip.ret.origin.id != this.booking.trip.out.destination.id) {
                    ports.push(this.getPortById(this.booking.trip.ret.origin.id))
                }
                if (this.booking.trip.ret.destination.id != this.booking.trip.out.origin.id) {
                    ports.push(this.getPortById(this.booking.trip.ret.destination.id))
                }
            }

            this.$nextTick(() => {
                ports.forEach(port => this.initMap(port))
            })

            return ports
        },
        prices() {
            let prices = {
                supplements: {},
                luggage: {
                    total: 0,
                    quantity: 0,
                },
                tickets: {},
            }

            let isReturn = !!this.booking.trip.ret

            let categoryLabels = {
                ADL: 'Adult',
                CHD: 'Child',
                INF: 'Infant',
            }

            this.booking.tickets.forEach(ticket => {
                if (!prices.tickets[ticket.passenger.category]) {
                    prices.tickets[ticket.passenger.category] = {
                        quantity: 0,
                        total: 0,
                        category: categoryLabels[ticket.passenger.category],
                        class: ticket.class.name,
                    }
                }
                let passengerTotal = parseFloat(ticket.passenger.prices.out.total) + (isReturn ? parseFloat(ticket.passenger.prices.ret.total) : 0)
                prices.tickets[ticket.passenger.category].quantity += 1
                prices.tickets[ticket.passenger.category].total += passengerTotal

                ticket.supplements.forEach(supplement => {
                    if (!prices.supplements[supplement.code]) {
                        prices.supplements[supplement.code] = {
                            code: supplement.code,
                            name: supplement.name,
                            quantity: 0,
                            total: 0,
                        }
                    }
                    let supplementTotal = parseFloat(supplement.prices.out.total) + (isReturn ? parseFloat(supplement.prices.ret.total) : 0)
                    prices.supplements[supplement.code].quantity += supplement.quantity
                    prices.supplements[supplement.code].total += supplementTotal
                })

                if (ticket.luggage.quantity) {
                    let luggageTotal = parseFloat(ticket.luggage.prices.out.total) + (isReturn ? parseFloat(ticket.luggage.prices.ret.total) : 0)
                    prices.luggage.quantity += ticket.luggage.quantity
                    prices.luggage.total += luggageTotal
                }
            })

            if (this.booking.tickets[0].transfers.length) {
                let transfer = this.booking.tickets[0].transfers[0]

                prices.transfer = {
                    name: transfer.name,
                    time: transfer.pickup_time,
                    quantity: this.booking.tickets.length,
                    total: this.booking.tickets.reduce(
                        (total, ticket) => total + ticket.transfers.reduce(
                            (total, transfer) => total + parseFloat(transfer.total)
                            , 0)
                        , 0)
                }
            }


            return {
                supplements: Object.values(prices.supplements),
                tickets: Object.values(prices.tickets),
                luggage: prices.luggage,
                transfer: prices.transfer,
            }
        }
    },
    async mounted() {
        let search = new URLSearchParams(window.location.search)
        this.bookingNumber = search.get('number')
        this.signature = search.get('signature')

        if (this.bookingNumber && this.signature) {
            await this.getBooking()
            if (!this.booking) {
                const that = this
                let requestCount = 0
                // Check booking every 3 seconds (awaiting payment confirmation)
                this.interval = setInterval(function () {
                    that.getBooking()
                    requestCount ++
                    if (requestCount >= 10) {
                        that.loading = false
                        clearInterval(that.interval)
                    }
                }, 3000)
            }
        } else {
            this.setStep('')
        }
    },
    methods: {
        ...mapMutations('booking', [
            'setStep',
        ]),
        initMap(port) {
            let lat = parseFloat(port.lat)
            let lng = parseFloat(port.lng)

            if (!lat || !lng) return;

            let center = {lat: lat, lng: lng }

            let map = new google.maps.Map(document.getElementById('port-map-'+port.id), {
                zoom: 15,
                center: center,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                draggable: false,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            })

            new google.maps.Marker({
                position: center,
                map: map,
                icon: window.venezialines.theme_root + '/assets/media/icons/google-marker-active.svg',
                animation: google.maps.Animation.DROP,
            })
        },
        getCountryName(code) {
            let country = countries.find(country => country.alpha3.toLowerCase() == code.toLowerCase())
            return country ? country.name : '-'
        },
        getLuggageInfo() {
            if (!this.booking) return

            this.$api.luggageInfo({
                out_origin_id: this.booking.trip.out.origin.id,
                out_destination_id: this.booking.trip.out.destination.id,
                out_trip_id: this.booking.trip.out.id,
                class: this.booking.tickets[0].class.code,
                ...(this.booking.trip.ret && {
                    ret_origin_id: this.booking.trip.ret.origin.id,
                    ret_destination_id: this.booking.trip.ret.destination.id,
                    ret_trip_id: this.booking.trip.ret.id,
                })
            }).then(response => this.luggageInfo = response)
        },
        getBooking() {
            this.$api.booking({
                number: this.bookingNumber,
                signature: this.signature,
            }).then(response => {
                if (response.number) {
                    this.booking = response
                    this.getLuggageInfo()
                }
            }).finally(() => {
                if (this.booking) {
                    this.loading = false
                    this.interval &&  clearInterval(this.interval)
                }
            })
        },
        reload() {
            window.location.reload()
        }
    }
}
</script>